import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SnChannelType, SnPublicity } from '../../enums';
import { SnChannel } from '../../models';

@Component({
  selector: 'sn-channel-status',
  templateUrl: './channel-status.component.html',
  styleUrls: ['./channel-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnChannelStatusComponent {
  @Input()
  get channel(): SnChannel {
    return this._channel;
  }
  set channel(value: SnChannel) {
    if (!value) {
      return;
    }
    this._channel = value;

    if (value.type === SnChannelType.Pair) {
      this.userSid = value.user;
    }
    this.memberCount = value.membersCount;
  }

  public userSid: string;
  public memberCount: number;

  private _channel: SnChannel;

  constructor() {}

  get isPublic(): boolean {
    return this._channel.publicity && this._channel.publicity === SnPublicity.Public;
  }
}
